<template>
    <nav id="navbarys" class="navbar navbar-expand-lg #navbar-light bg-semi-light #fixed-top">
        <a class="navbar-brand" href="#">
            <img src="@/assets/logo1.png" alt="logo" class="ml-3" style="width: 50px;">
            <img src="@/assets/Tracé.png" alt="logo" class="ml-3">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="d-flex ml-auto order-lg-last nav-actions" style="margin-right: 20px;">
            <div class="notification-menu hide-on-mobile">
                <button type="button" class="notification-button" @click="openNotificationsModal()">
                    <i class="far fa-bell"></i>
                    <span v-if="notificationCount > 0" class="notification-badge">
                        {{ notificationCount }}
                    </span>
                </button>
            </div>
            <div class="user-menu">
                <button class="user-menu-button" @click="toggleUserMenu" type="button">
                    <i class="fa-solid fa-chevron-down text-sm hide-on-mobile"></i>
                    <span class="user-name hide-on-mobile">
                        {{ userName }}
                    </span>
                    <img :src="userPhoto" class="user-avatar" alt="Photo de profil">
                </button>
                <div class="user-menu-dropdown" :class="{ 'active': isUserMenuOpen }">
                    <a href="#mon-profil" class="user-menu-item" @click.prevent="openProfileModal()">
                        <i class="fas fa-user"></i>
                        <span>Mon profil</span>
                    </a>
                    <a href="#se-deconnecter" class="user-menu-item logout" @click.prevent="logout()">
                        <i class="fas fa-arrow-right"></i>
                        <span>Se déconnecter</span>
                    </a>
                </div>
            </div>
        </div>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    </nav>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
const NotificationComponent = defineAsyncComponent(() => import('@/components/NotificationComponent.vue'));
const MessageComponent = defineAsyncComponent(() => import('@/components/MessageComponent.vue'));
const MyProfile = defineAsyncComponent(() => import('@/auth/MyProfile.vue'));

export default defineComponent({
    name: 'NavBar',
    data() {
        return {
            isLoading: false,
            isFullscreen: false,
            isUserMenuOpen: false // Ajout de cette ligne
        }
    },
    mounted() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
        document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
        document.addEventListener('MSFullscreenChange', this.onFullscreenChange);
    },
    beforeDestroy() {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
        document.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
        document.removeEventListener('MSFullscreenChange', this.onFullscreenChange);
    },
    computed: {
        ...mapGetters(['notificationCount', 'messageCount']),
        userName() {
            return this.$store.getters.user ? this.$store.getters.user.name : '';
        },
        userPhoto() {
            return this.$store.getters.user ? this.$store.getters.user.photo : '';
        }
    },
    methods: {
        ...mapActions(['stopFetchingNotifications', 'stopFetchingMessages']),
        logout() {
            this.isLoading = true
            
            // Fonction commune pour effectuer la déconnexion locale
            const performLocalLogout = () => {
                // Arrêter les processus en arrière-plan
                this.stopFetchingNotifications()
                this.stopFetchingMessages()
                
                // Effacer les données utilisateur
                this.$store.commit('clearUserData')
                
                // Rediriger vers la page de connexion
                this.$router.push({ name: 'login' })
                
                this.isLoading = false
            }
            
            // Essayer de se déconnecter côté serveur
            this.axios.post('/api/logout')
                .then(response => {
                    if (response.data.success === true) {
                        this.$toast.add({
                            severity: 'success',
                            detail: response.data.message,
                            life: 3000
                        });
                    } else {
                        response.data.errors.forEach(element => {
                            this.$toast.add({
                                severity: 'warn',
                                summary: 'Attention',
                                detail: element,
                                life: 8000
                            });
                        });
                    }
                    
                    // Dans tous les cas, effectuer la déconnexion locale
                    performLocalLogout();
                })
                .catch(() => {
                    // En cas d'erreur de connexion, effectuer quand même la déconnexion locale
                    performLocalLogout();
                    
                    // Informer l'utilisateur que la déconnexion serveur a échoué mais qu'il est bien déconnecté localement
                    this.$toast.add({
                        severity: 'info',
                        summary: 'Déconnexion locale',
                        detail: 'Vous avez été déconnecté localement, mais la déconnexion côté serveur a échoué.',
                        life: 5000
                    });
                });
        },
        openProfileModal() {
            this.$dialog.open(MyProfile, {
                props: {
                    header: "Mon compte",
                    style: {
                        width: '40vw'
                    },
                    modal: true
                },
            });
        },
        toggleFullscreen() {
            if (!this.isFullscreen) {
                this.enterFullscreen();
            } else {
                this.exitFullscreen();
            }
        },
        enterFullscreen() {
            const elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { // Firefox
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { // Chrome, Safari and Opera
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { // IE/Edge
                elem.msRequestFullscreen();
            }
            this.isFullscreen = true;
        },
        exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
            this.isFullscreen = false;
        },
        onFullscreenChange() {
            this.isFullscreen = !!(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            );
        },
        openNotificationsModal() {
            this.$dialog.open(NotificationComponent, {
                props: {
                    header: "Notifications",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
            });
        },
        openMessagesModal() {
            this.$dialog.open(MessageComponent, {
                props: {
                    header: "Messages",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
            });
        },
        toggleUserMenu() {
            this.isUserMenuOpen = !this.isUserMenuOpen;
        },

        // Fermer le menu quand on clique ailleurs
        closeUserMenu(event) {
            if (!event.target.closest('.user-menu')) {
                this.isUserMenuOpen = false;
            }
        }
    },
    mounted() {
        // Autres code de mounted existant
        document.addEventListener('click', this.closeUserMenu);
    },

    beforeUnmount() {
        // Autres code de beforeUnmount existant
        document.removeEventListener('click', this.closeUserMenu);
    }
})
</script>

<style scoped>
/* Ajout de styles pour la disposition des boutons */
.nav-actions {
    display: flex;
    align-items: center;
    margin-right: 20px;
}

/* Style du bouton de notifications */
.notification-menu {
    position: relative;
    margin-right: 0.5rem;
}

.notification-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #f8f9fa;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.notification-button:hover {
    background-color: #e9ecef;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.notification-button i {
    font-size: 1.1rem;
    color: #343a40;
}

.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    background-color: #dc3545;
    color: white;
    font-size: 0.7rem;
    font-weight: bold;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
}

.bg-semi-light {
    background-color: rgba(255, 255, 255, 0.9)
}

/* Style du menu utilisateur */
.user-menu {
    position: relative;
    margin-left: 0.5rem;
}

.user-menu-button {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #f8f9fa;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.user-menu-button:hover {
    background-color: #e9ecef;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.user-name {
    margin: 0 0.5rem;
    font-weight: 500;
    color: #343a40;
}

.user-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.user-menu-dropdown {
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    width: 200px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.2s ease-in-out;
    z-index: 1000;
    overflow: hidden;
}

.user-menu-dropdown.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.user-menu-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    color: #495057;
    text-decoration: none;
    transition: all 0.2s ease;
}

.user-menu-item i {
    margin-right: 10px;
    font-size: 0.9rem;
}

.user-menu-item:hover {
    background-color: #f8f9fa;
    color: #3242c5;
}

.user-menu-item.logout {
    color: #dc3545;
    border-top: 1px solid #f1f1f1;
}

.user-menu-item.logout:hover {
    background-color: #fff8f8;
}

.navbar {
    flex-wrap: nowrap !important;
}

@media (max-width: 992px) {
    .nav-actions {
        margin-right: 20px !important;
        position: absolute;
        right: 0;
    }

    /* Réduire la taille des boutons sur mobile */
    .notification-button,
    .user-menu-button {
        width: 36px;
        height: 36px;
        padding: 0.35rem;
    }

    .user-menu-button {
        border-radius: 50%;
        /* Faire un cercle en mobile */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* Notification menu is hidden by adding hide-on-mobile class in the template */

    .user-avatar {
        width: 28px;
        height: 28px;
        margin: 0;
        /* Remove any margin */
    }

    .hide-on-mobile {
        display: none !important;
    }

    .user-menu-button {
        padding: 0.5rem;
    }

    .user-avatar {
        margin-left: 0;
    }



    /* Ajuster l'apparence du bouton profil en mode mobile */
    .navbar-nav .btn.dropdown {
        padding: 1rem;
        border-radius: 50%;
    }
}

/* Ajouter des styles pour les écrans très petits */
@media (max-width: 375px) {




    .user-avatar {
        width: 26px;
        height: 26px;
    }

    .user-menu-button {
        width: 32px;
        height: 32px;
        padding: 0.25rem;
    }
}
</style>